/**
 * Registra o Service Worker para transformar o portal em PWA instalável e cacheável.
 * Ativo apenas em produção (build) para não interferir no hot reload durante dev.
 * Também trata a promoção do prompt "beforeinstallprompt" via evento customizado.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Registra em produção (após build) — no dev server o SW pode servir HTML antigo
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        // Verifica updates a cada 60min
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);

        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // Nova versão pronta — dispara evento para UI mostrar botão "Atualizar"
              window.dispatchEvent(new CustomEvent("bauen:sw-updated", { detail: { registration } }));
            }
          });
        });
      })
      .catch(() => { /* silencioso: falha na registration não deve quebrar o app */ });
  });

  // Captura o prompt de instalação nativo
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__bauenInstallPrompt = e;
    window.dispatchEvent(new CustomEvent("bauen:install-available"));
  });

  window.addEventListener("appinstalled", () => {
    window.__bauenInstallPrompt = null;
    window.dispatchEvent(new CustomEvent("bauen:installed"));
  });
}
